// extracted by css-extract-rspack-plugin
export default {"Text":"ChecksStatusBadgeHeader-module__Text__rAn28cz","Text_1":"ChecksStatusBadgeHeader-module__Text_1__fWLvjdG","Text_2":"ChecksStatusBadgeHeader-module__Text_2__CSwvbLe"};